import { render } from "./EventEditPanel.vue?vue&type=template&id=03f87c0a&scoped=true"
import script from "./EventEditPanel.vue?vue&type=script&lang=js"
export * from "./EventEditPanel.vue?vue&type=script&lang=js"

import "./EventEditPanel.vue?vue&type=style&index=0&id=03f87c0a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f87c0a"]])

export default __exports__